<template>
  <div class="app-shell">
    <app-bar />
    <drawer />

    <v-main class="app-main">
      <router-view />
    </v-main>
  </div>
</template>

<script>
export default {
  name: "Index",

  components: {
    AppBar: () => import("./components/AppBar"),
    Drawer: () => import("./components/Drawer"),
  },

  data: () => ({
    expandOnHover: true,
  }),
};
</script>

<style scoped>
.app-shell {
  min-height: 100vh;
}
</style>
